import Toast from '../components/pages/utils/Toast';
import { API } from '../constants/Constants';
import Instance from './interceptor';

const getAllGoogleToken = async (codes) => {
  try {
    const response = await Instance.get(`${API.GET_GOOGLE_TOKEN}`, {
      params: {
        codes,
      },
    });
    if (response.data) {
      return response.data?.getTokens;
    }
  } catch (error) {
    Toast({
      message: `${error?.response?.getTokens?.errorMessage}`,
      variant: 'error',
    });
  }
};

export default getAllGoogleToken;
